import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/data/content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      return window.localStorage.getItem("byvaya-lang") || "en";
    }
    return "en";
  });

  const setLanguage = useCallback((next) => {
    setLang(next);
    if (typeof window !== "undefined") {
      window.localStorage.setItem("byvaya-lang", next);
    }
  }, []);

  const toggle = useCallback(() => {
    setLanguage(lang === "en" ? "de" : "en");
  }, [lang, setLanguage]);

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLanguage, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
